import { useEffect, useState } from 'react';

/** 数え直す間隔（ミリ秒）。本文の逐次更新（C27）と同じ 1 秒。 */
export const TICK_MS = 1000;

/**
 * 動いている間だけ 1 秒ごとに進む「いま」（ミリ秒）。止めると最後に読んだ値のまま。
 * 経過時間の表示だけに使う（時刻の取得は Date.now のまま）。
 */
export function useNow(ticking: boolean): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!ticking) return;
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), TICK_MS);
    return () => clearInterval(timer);
  }, [ticking]);
  return now;
}

/** since からの経過秒。読めない時刻と未来の時刻は 0。 */
export function elapsedSeconds(since: string | null, now: number): number {
  if (since === null) return 0;
  const started = Date.parse(since);
  return Number.isNaN(started) ? 0 : Math.max(0, Math.floor((now - started) / 1000));
}
